export default {
    variants: {
        navLocaleMenu: {
            list: {
                width: 'xs',
                minWidth: '240px',
                borderColor: 'transparent',
                borderRadius: 'base',
                boxShadow: '0px 1px 12px rgba(0, 0, 0, 0.25)'
            },
            item: {
                position: 'relative',
                textTransform: 'uppercase',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                textDecoration: 'none',
                bg: 'white',
                color: 'fullBlack',
                borderRadius: 'none',
                fontSize: 'md',
                fontFamily: 'body',
                fontWeight: 500,
                width: 'auto',
                height: '50px',
                minWidth: 10,
                px: '32px',
                py: 0,
                lineHeight: 1,
                _focusVisible: {
                    outline: '2px solid transparent',
                    boxShadow: 'outline',
                    zIndex: 1
                }
            }
        },
        footerLocaleMenu: {
            list: {
                width: '100px',
                minWidth: '100px',
                borderColor: 'transparent',
                borderRadius: 'base',
                boxShadow: '0px 1px 12px rgba(0, 0, 0, 0.25)',
                bg: 'lightBeige',
                padding: '0 16px'
            },
            item: {
                position: 'relative',
                display: 'block',
                textAlign: 'center',
                textTransform: 'none',
                textDecoration: 'none',
                bg: 'lightBeige',
                color: 'fullBlack',
                borderRadius: 'none',
                fontSize: 'md',
                fontFamily: 'body',
                fontWeight: 500,
                width: '100%',
                height: 'auto',
                py: '12px',
                pl: '2px',
                lineHeight: 1,
                _focusVisible: {
                    outline: '2px solid transparent',
                    boxShadow: 'outline',
                    zIndex: 1
                },
                _hover: {
                    textDecoration: 'none'
                }
            }
        }
    }
}
